import { useCallback } from 'react';

import { SECONDS_IN_MINUTE } from '~/common';

import { useSecondConsumed } from './useSecondConsumed';
import {
  convertSecondsInMinutes,
  getMediaDurationInMinutes,
  getMediaDurationInSeconds,
} from './utils';
import { useMediaPlayer } from '../MediaPlayerProvider';

export type OnMinuteConsumedCbParams = {
  mediaDurationMinutes: number;
  totalMinutesConsumed: number;
};
export function useMinuteConsumed(cb: (params: OnMinuteConsumedCbParams) => void) {
  const { player } = useMediaPlayer();

  const onSecondConsumedHandler = useCallback(() => {
    if (player !== null) {
      const mediaDurationInSeconds = getMediaDurationInSeconds(player);

      const consumedSeconds = player.consumedSeconds();
      const isAnotherMinuteConsumes = consumedSeconds % SECONDS_IN_MINUTE === 0;
      if (isAnotherMinuteConsumes && consumedSeconds <= mediaDurationInSeconds) {
        const mediaDurationMinutes = getMediaDurationInMinutes(player);
        const totalMinutesConsumed = convertSecondsInMinutes(consumedSeconds);

        cb({ mediaDurationMinutes, totalMinutesConsumed });
      }
    }
  }, [cb, player]);

  useSecondConsumed(onSecondConsumedHandler);
}
